export const DASHBOARD_ROUTES = [
    {
        title: 'Настройки профиля',
        pathname: '/my-profile',
    },
    {
        title: 'Финансы',
        pathname: ['/exam-with-payment'],
    },
    {
        title: 'Черновик',
        pathname: ['/exam-draft/*'],
    },
    {
        title: 'Экзамены',
        pathname: [
            '/new-exam/*',
            '/exam-list',
            '/exam-applications',
            '/exam-experts/*',
            '/applicants',
            '/applicant-details/*',
            '/exam/*',
        ],
    },
    {
        title: 'Управление ЭЦ',
        pathname: [
            '/ec-experts',
            '/qec-list',
            '/expert/*',
            '/ec-list', '/ec-details/*',
        ],
    },
];
